import { uniqWith, isEqual } from 'lodash';
import * as types from '../constants/ActionTypes';
import { translateItemTypesName, groupByName, sort } from '../lib/ExerciseUtils';

export const initialState = {
    authorsList: [],
    authorsLoaded: true,
    homeworkAuthorsList: [],
    homeworkAuthorsLoaded: true,
    subjectsList: [],
    subjectsLoaded: true,
    invalsiSubjectsList: [],
    invalsiSubjectsLoaded: true,
    homeworkSubjectsList: [],
    homeworkSubjectsLoaded: true,
    booksList: [],
    booksLoaded: true,
    homeworkBooksList: [],
    homeworkBooksLoaded: true,
    itemTypesList: [],
    itemTypesLoaded: true,
    showFilters: false
};

export default function getFilters(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_SUBJECTS:
            return action.isHomework
                ? {
                      ...state,
                      homeworkSubjectsLoaded: false
                  }
                : {
                      ...state,
                      subjectsLoaded: false
                  };
        case types.GET_SUBJECTS_SUCCESS:
            let noContent = !Array.isArray(action.result);
            return action.isHomework
                ? {
                      ...state,
                      homeworkSubjectsList: noContent ? [] : groupByName(action.result),
                      homeworkSubjectsLoaded: true
                  }
                : {
                      ...state,
                      subjectsList: noContent ? [] : groupByName(action.result),
                      subjectsLoaded: true
                  };
        case types.GET_SUBJECTS_FAILURE:
            return action.isHomework
                ? {
                      ...state,
                      homeworkSubjectsList: [],
                      homeworkSubjectsLoaded: true
                  }
                : {
                      ...state,
                      subjectsList: [],
                      subjectsLoaded: true
                  };
        case types.GET_BOOKS:
            return action.isHomework
                ? {
                      ...state,
                      homeworkBooksLoaded: false
                  }
                : {
                      ...state,
                      booksLoaded: false
                  };
        case types.GET_BOOKS_SUCCESS: {
            const books = action.result;
            const noContent = !Array.isArray(books);
            return action.isHomework
                ? {
                      ...state,
                      homeworkBooksList: noContent ? [] : groupByName(action.result),
                      homeworkBooksLoaded: true
                  }
                : {
                      ...state,
                      booksList: noContent ? [] : groupByName(books),
                      booksLoaded: true
                  };
        }
        case types.GET_BOOKS_FAILURE:
            return action.isHomework
                ? {
                      ...state,
                      homeworkBooksList: [],
                      homeworkBooksLoaded: true
                  }
                : {
                      ...state,
                      booksList: [],
                      booksLoaded: true
                  };
        case types.GET_AUTHORS:
            return action.isHomework
                ? {
                      ...state,
                      homeworkAuthorsLoaded: false
                  }
                : {
                      ...state,
                      authorsLoaded: false
                  };
        case types.GET_AUTHORS_SUCCESS:
            let res = [];
            if (Array.isArray(action.result)) {
                res = uniqWith(sort(action.result), isEqual);
            }
            return action.isHomework
                ? {
                      ...state,
                      homeworkAuthorsList: res,
                      homeworkAuthorsLoaded: true
                  }
                : {
                      ...state,
                      authorsList: res,
                      authorsLoaded: true
                  };
        case types.GET_AUTHORS_FAILURE:
            return action.isHomework
                ? {
                      ...state,
                      homeworkAuthorsList: [],
                      homeworkAuthorsLoaded: true
                  }
                : {
                      ...state,
                      authorsList: [],
                      authorsLoaded: true
                  };
        case types.GET_ITEM_TYPES:
            return {
                ...state,
                itemTypesLoaded: false
            };
        case types.GET_ITEM_TYPES_SUCCESS:
            let itemTypesName = [];
            if (Array.isArray(action.result)) {
                action.result.map(el => {
                    if (el.name.startsWith('exercise.') && el.name !== 'exercise.checker') {
                        return itemTypesName.push({ id: el.id, name: translateItemTypesName(el.name) });
                    } else {
                        return undefined;
                    }
                });
                itemTypesName.sort((a, b) => {
                    let textA = a.name.toUpperCase();
                    let textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            }

            return {
                ...state,
                itemTypesList: itemTypesName,
                itemTypesLoaded: true
            };
        case types.GET_ITEM_TYPES_FAILURE:
            return {
                ...state,
                itemTypesList: [],
                itemTypesLoaded: true
            };
        case types.SHOW_FILTERS:
            return {
                ...state,
                showFilters: !state.showFilters
            };
        default:
            return state;
    }
}
